// extracted by mini-css-extract-plugin
export default {"contentWrapper":"AboutUs_contentWrapper__73GeY","aboutUsDataWrapper":"AboutUs_aboutUsDataWrapper__pW0ZU"};